import { render } from "./StatsPopup.vue?vue&type=template&id=0e59be87&scoped=true"
import script from "./StatsPopup.vue?vue&type=script&lang=js"
export * from "./StatsPopup.vue?vue&type=script&lang=js"

import "./StatsPopup.vue?vue&type=style&index=0&id=0e59be87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e59be87"]])

export default __exports__